<template>
  <div>
    <h2 class="step-name">Mastitis Goals</h2>

    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <discussion-points title="Mastitis Goals"
                             :comments-field="`farm_${farm.id}-drycow_mastitis_goals`"
                             points="Bulk milk, somatic cell count & clinical cases.">
          </discussion-points>

          <discussion-points title="Herd Testing and Culling"
                             :comments-field="`farm_${farm.id}-herd_testing_and_culling`"
                             points="Number of herd tests, date of last herd test, criteria for mastitis culling">
          </discussion-points>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'MastitisGoals',
  mixins: [ baseComponent ],
};
</script>

